import React from 'react';
import usePortfolioLogic from './hooks/usePortfolioLogic';
import PortfolioDesktop from './components/PortfolioDesktop';
import PortfolioMobile from './components/PortfolioMobile';

function Portfolio() {
  const { screenSize } = usePortfolioLogic();

  return screenSize === 'mobile' ? <PortfolioMobile /> : <PortfolioDesktop />;
}

export default Portfolio;
